export const Ornament = ({ className = "w-16" }) => (
  <svg viewBox="0 0 64 32" fill="none" className={className} aria-hidden="true">
    <g stroke="currentColor" strokeWidth="2.2" strokeLinecap="round">
      <path d="M32 30 V16 C32 6 44 2 50 8 C55 13 52 20 46 19 C42 18 42 13 46 13" />
      <path d="M32 16 C32 6 20 2 14 8 C9 13 12 20 18 19 C22 18 22 13 18 13" />
      <path d="M32 24 C38 24 42 28 46 28 M32 24 C26 24 22 28 18 28" />
    </g>
  </svg>
);

export const OrnamentLine = ({ className = "" }) => (
  <div className={`flex items-center gap-4 text-[var(--gold)] ${className}`} aria-hidden="true">
    <span className="h-px flex-1 bg-[linear-gradient(90deg,transparent,var(--gold))]" />
    <Ornament className="w-14" />
    <span className="h-px flex-1 bg-[linear-gradient(270deg,transparent,var(--gold))]" />
  </div>
);
